// Instagram username validation rules:
// - Username must be between 1 and 30 characters
// - Can contain letters, numbers, periods, and underscores
// - Cannot contain consecutive periods

export const validateInstagramUsername = (username: string): boolean => {
  if (!username) return true; // Allow empty string for deletion
  
  // Remove @ if present
  username = username.startsWith('@') ? username.slice(1) : username;
  
  // Allow underscores anywhere in the username
  const regex = /^[a-zA-Z0-9._][a-zA-Z0-9._]*$/;
  
  return (
    username.length >= 1 &&
    username.length <= 30 &&
    regex.test(username) &&
    !username.includes('..')
  );
};

export const isValidInstagramChar = (char: string): boolean => {
  return /^[a-zA-Z0-9._@]$/.test(char);
};

export const isValidInstagramUsername = (value: string): boolean => {
  return !value || validateInstagramUsername(value);
};